<script lang="ts">
  import slugify from 'slugify';
  import { cn } from '$lib/utils';
  export let id: string;
  export let level: number;
  const slugifyFromText = (text: string) => {
    // return text?.replace(/ /g, '-').toLowerCase();
    return slugify(text).toLowerCase();
  };

  const classes = {
    h1: 'scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl',
    h2: 'mt-10 scroll-m-20 border-b pb-2 text-3xl font-semibold tracking-tight transition-colors first:mt-0',
    h3: 'mt-8 scroll-m-20 text-2xl font-semibold tracking-tight',
    h4: 'mt-6 scroll-m-20 text-xl font-semibold tracking-tight'
  };

  const slugId = slugifyFromText(id);
  const tagLevel = String(level);
  let tag = `h${tagLevel}`;

  let tagClasses = classes.hasOwnProperty(tag) ? classes[tag] : classes.h1;
</script>

<svelte:element this={tag} id={slugId} class={cn(tagClasses, 'group')}>
  <span>
    <slot />
  </span>
  <span class="inline-block sm:hidden group-hover:sm:inline-block">
    <a href={`#${slugId}`} class="hover:text-orange-800">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="h-5 w-5"
      >
        <path
          fill-rule="evenodd"
          d="M19.902 4.098a3.75 3.75 0 00-5.304 0l-4.5 4.5a3.75 3.75 0 001.035 6.037.75.75 0 01-.646 1.353 5.25 5.25 0 01-1.449-8.45l4.5-4.5a5.25 5.25 0 117.424 7.424l-1.757 1.757a.75.75 0 11-1.06-1.06l1.757-1.757a3.75 3.75 0 000-5.304zm-7.389 4.267a.75.75 0 011-.353 5.25 5.25 0 011.449 8.45l-4.5 4.5a5.25 5.25 0 11-7.424-7.424l1.757-1.757a.75.75 0 111.06 1.06l-1.757 1.757a3.75 3.75 0 105.304 5.304l4.5-4.5a3.75 3.75 0 00-1.035-6.037.75.75 0 01-.354-1z"
          clip-rule="evenodd"
        />
      </svg>
    </a>
  </span>
</svelte:element>
